const config = ({
    // eslint-disable-next-line no-undef
    apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3000/api"
})

export default config